import { combineReducers } from 'redux'

import user from './user'
import adWatches from './adWatches'
import savedAds from './savedAds'
import adWatchAds from './adWatchAds'

export default combineReducers({
  user,
  adWatches,
  savedAds,
  adWatchAds,
})
